import React, { SVGAttributes } from 'react';

export function RewardsBalanceIcon(props: SVGAttributes<unknown>): JSX.Element {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none' {...props}>
      <path
        d='M3.99143 9.72656L1.16602 13.1795L3.77762 13.7018L4.82227 16.8357L7.56898 12.4775'
        stroke='#3387E1'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.0092 9.72656L16.8346 13.1795L14.223 13.7018L13.1784 16.8357L10.4316 12.4775'
        stroke='#3387E1'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3.25391 6.9096C3.25391 7.66411 3.40252 8.41124 3.69126 9.10832C3.98 9.8054 4.40321 10.4388 4.93673 10.9723C5.47026 11.5058 6.10364 11.929 6.80072 12.2178C7.4978 12.5065 8.24493 12.6551 8.99944 12.6551C9.75396 12.6551 10.5011 12.5065 11.1982 12.2178C11.8952 11.929 12.5286 11.5058 13.0621 10.9723C13.5957 10.4388 14.0189 9.8054 14.3076 9.10832C14.5964 8.41124 14.745 7.66411 14.745 6.9096C14.745 6.15508 14.5964 5.40796 14.3076 4.71088C14.0189 4.0138 13.5957 3.38041 13.0621 2.84689C12.5286 2.31337 11.8952 1.89016 11.1982 1.60142C10.5011 1.31268 9.75396 1.16406 8.99944 1.16406C8.24493 1.16406 7.4978 1.31268 6.80072 1.60142C6.10364 1.89016 5.47026 2.31337 4.93673 2.84689C4.40321 3.38041 3.98 4.0138 3.69126 4.71088C3.40252 5.40796 3.25391 6.15508 3.25391 6.9096Z'
        stroke='#3387E1'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.37051 3.6328L10.2396 5.34462H11.721C11.8025 5.34263 11.8827 5.36529 11.9512 5.40964C12.0197 5.45398 12.0732 5.51796 12.1047 5.59319C12.1362 5.66842 12.1443 5.75142 12.1279 5.83132C12.1115 5.91122 12.0714 5.98432 12.0128 6.04105L10.6526 7.3768L11.4062 9.10743C11.4394 9.18669 11.4469 9.27438 11.4276 9.35812C11.4082 9.44187 11.3631 9.51743 11.2986 9.57415C11.234 9.63086 11.1532 9.66587 11.0677 9.67422C10.9822 9.68257 10.8962 9.66385 10.8219 9.6207L9.0007 8.59625L7.17954 9.6207C7.10522 9.66385 7.01923 9.68257 6.93369 9.67422C6.84816 9.66587 6.76741 9.63086 6.70284 9.57415C6.63828 9.51743 6.59316 9.44187 6.57385 9.35812C6.55454 9.27438 6.56202 9.18669 6.59524 9.10743L7.34877 7.3768L5.98865 6.03827C5.93004 5.98153 5.88991 5.90844 5.87351 5.82853C5.85711 5.74863 5.8652 5.66564 5.89672 5.5904C5.92825 5.51517 5.98173 5.4512 6.0502 5.40685C6.11866 5.36251 6.19891 5.33985 6.28045 5.34184H7.76176L8.6316 3.6328C8.6671 3.5656 8.72027 3.50935 8.78537 3.47012C8.85047 3.43089 8.92504 3.41016 9.00105 3.41016C9.07706 3.41016 9.15163 3.43089 9.21673 3.47012C9.28183 3.50935 9.335 3.5656 9.37051 3.6328Z'
        fill='#99C3F0'
        stroke='#3387E1'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
